import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('de') ? 'de' : 'en';

  const toggleLanguage = () => {
    const newLang = currentLang === 'de' ? 'en' : 'de';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="terminal-border px-2 py-1.5 sm:px-3 sm:py-1.5 text-xs sm:text-sm font-mono bg-background hover:bg-primary/10 transition-colors whitespace-nowrap"
      aria-label="Toggle language"
    >
      <span className={currentLang === 'de' ? 'text-primary terminal-glow' : 'text-muted-foreground'}>
        DE
      </span>
      <span className="text-muted-foreground mx-1">|</span>
      <span className={currentLang === 'en' ? 'text-primary terminal-glow' : 'text-muted-foreground'}>
        EN
      </span>
    </button>
  );
};

export default LanguageSwitcher;
